import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import { reviewData } from '../review-data';
import { buildReviewListSchema } from '../review-schema.util';
import type { ReviewVariantSchemaData } from '../star-reviews/star-reviews.schema';

const VARIANT_ID_FRAGMENT = 'reviews-carousel';
const DEFAULT_LIST_NAME = 'Customer Testimonials';

/**
 * Returns Review nodes + an ItemList for the carousel-reviews variant. Reviews are
 * sourced from `reviewData[1]`. Carousel testimonials include `date` so each Review
 * gets a `datePublished` when parseable.
 */
export function getCarouselReviewsSchema(data: ReviewVariantSchemaData | null): SchemaOrgNode[] | null {
  if (!data) return null;
  return buildReviewListSchema({
    listId: `${data.pageUrl}#${VARIANT_ID_FRAGMENT}`,
    listName: data.reviewTitle?.trim() || DEFAULT_LIST_NAME,
    siteUrl: data.siteUrl,
    organizationName: data.organizationName,
    items: reviewData[1],
  });
}
